import {StorageType} from "../../utils/enums";
import {NcaAction, SignService} from "./sign.service";
import {NcaLayerResponse} from "../../types/ncaLayer";

export const NCA_LAYER_URI = "wss://127.0.0.1:13579";


const signXML = (type: NcaAction, xml: string): Promise<NcaLayerResponse> => {
    const sign = new SignService()

    return sign.callNcaLayer(type, xml)
}

const signCms = (type: NcaAction, data: string): Promise<NcaLayerResponse> => {
    const sign = new SignService()
    return sign.callNcaLayerCms(type, data)
}



// интерфейс модуля
export interface SignatureUse {
    signXML: (type: NcaAction, xml: string) => Promise<NcaLayerResponse>
    signCms: (type: NcaAction, data: string) => Promise<NcaLayerResponse>
}

// использование модуля
export default function useSignature(): SignatureUse {
    return {
        signXML,
        signCms,
    }
}
